__turbopack_context__.v({
  "helperText": "uTZajW_helperText",
  "label": "uTZajW_label",
});
